import { useContext, useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import Menu from "../../../components/Menu/Menu";
import './Minigames.scss';
import useAuth from "../../../hooks/useAuth";
import NotAuthenticated from "../../../components/NotAuthenticated/NotAuthenticated";
import api from "../../../js/api";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../js/UserContext";
import useDialog from "../../../hooks/useDialog";

export default function GameCodeSelector() {

    const [room, setRoom] = useState('');
    const { gameName } = useParams();
    const navigate = useNavigate();
    const { user, loading } = useContext(UserContext);

    const [game_data, setGame_data] = useState(null);
    const { confirm, alert, prompt, DialogUI } = useDialog();

    useEffect(() => {
        if (!gameName) {
            return navigate('/misc/minigames', { replace: true });
        }

        api.get(`/games/` + gameName, { silent: true }).then((res) => {
            if (res && res.error) {
                return navigate('/misc/minigames', { replace: true });
            }

            setGame_data(res);
        }).catch((error) => {
            console.error('Error fetching game data:', error);
            navigate('/misc/minigames', { replace: true });
        });
    }, [])

    const authenticated = useAuth();
    if (authenticated === false) {
        return <NotAuthenticated />;
    }

    const loadGameData = () => {
        if (!game_data || loading) {
            return <p>Loading...</p>;
        }
        return (
            game_data ? (
                game_data && !game_data.error ? (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        {
                            Object.keys(game_data).map((key, index) => (
                                game_data[key] ?
                                    <p key={index}><b>{key}</b>: {game_data[key]}</p>
                                    :
                                    ''
                            ))
                        }
                    </div>
                ) : (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        <p>No game data found for user {user.login}</p>
                    </div>
                )
            ) : (
                <p>Loading...</p>
            )
        )
    }

    return (
        <div id='game-code-selector'>
            {DialogUI}
            <div className='centered-container'>
                <h1 className='title'>{gameName.charAt(0).toUpperCase() + gameName.slice(1)}</h1>
                <Button text="Create Room" onClick={async (e) => {
                    const currRooms = await api.get(`/users/${user.login}/rooms`, { silent: true });
                    if (currRooms.error) {
                        await alert('Error al obtener tus salas: ' + currRooms.error);
                        navigate('/misc/minigames', { replace: true });
                        return;
                    }
                    const gameRooms = currRooms.filter(r => r.game === gameName);
                    if (gameRooms.length >= 3) {
                        await alert(`Solo puedes tener 3 salas de ${gameName} a la vez. Elimina alguna antes de crear una nueva.`);
                        return;
                    }

                    const name = await prompt('Nombre de la sala:', '');
                    if (name === null) return;
                    if (name.trim() === '') {
                        await alert('El nombre no puede estar vacío.');
                        return;
                    }
                    const private_ = await confirm('¿Es esta sala privada?');
                    let password = null;
                    if (private_) {
                        password = await prompt('Contraseña de la sala:', '');
                        if (!password) {
                            await alert('Debes introducir una contraseña para una sala privada.');
                            return;
                        }
                    }
                    const r = await api.post(`/rooms`, {
                        game: gameName,
                        name: name,
                        is_private: private_,
                        password: password || null,
                    });
                    if (r.error) {
                        await alert('Error al crear la sala: ' + r.error);
                        return;
                    }
                    navigate('/misc/minigames/' + gameName + '/rooms/' + r.room.id);
                }} />
                <input type="number" className='game-code-selector-input' onChange={(e) => {
                    setRoom(e.target.value);
                }} />

                <Button text="Join Room" onClick={async () => {
                    if (!room) {
                        await alert('Introduce un código de sala.');
                        return;
                    }
                    navigate('/misc/minigames/' + gameName + '/rooms/' + room);
                }} />

                <Button text="My Rooms" onClick={async (e) => {
                    navigate('/misc/minigames/' + gameName + '/rooms?login=' + user.login);
                }} />

                <Button text="View All Rooms" onClick={async (e) => {
                    navigate('/misc/minigames/' + gameName + '/rooms');
                }} />

                <br />
                <br />
                {loadGameData()}
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    )
}